var redirectContext = {
    url: null,
    includeToken: false
}

function redirectedAwayFrom(toRoute) {
    if(toRoute.path == '/mfa') return false;    
    var apiToken = localStorage.getItem('apiToken') || null;

    if(redirectContext.url && apiToken) {
        var url = `${redirectContext.url}`;
        if(redirectContext.includeToken) {
            url += `?token=${apiToken}`;
        }
        
        window.location.href = url;
        return true;
    }

    if(toRoute && toRoute.query.redirectAuth) {
        redirectContext.includeToken = true;
        redirectContext.url = toRoute.query.redirectAuth;
    }

    return false;
}

export { redirectedAwayFrom };


// WEBPACK FOOTER //
// ./src/framework/login-redirect.js